import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getHmsSettings, HmsSettings, saveHmsSettings } from '../../../api/hmsSettings';

export const HmsSettingsQueryKey = 'HMS_SETTINGS';

export const useHmsSettingsQuery = (enabled = true) =>
  useQuery({ queryKey: [HmsSettingsQueryKey], queryFn: getHmsSettings, enabled });

/** Until the settings are loaded, the organisation is taken to use safety representatives, as most do */
export const useUsesSafetyReps = (enabled = true) => useHmsSettingsQuery(enabled).data?.usesSafetyReps ?? true;

export const useSaveHmsSettingsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (settings: HmsSettings) => saveHmsSettings(settings),
    // Every step of the HMS work shows or hides the safety representative from it
    onSuccess: () => queryClient.invalidateQueries(),
  });
};
